import { deleteCookie } from '@beef/utils';
import { CAPTCHA_ACTIVE_MESSAGE_ID, CAPTCHA_BEFORE_BLOCKING_HISTORY_KEY, CAPTCHA_QUEUED_MESSAGES, CAPTCHA_RETRY_KEY, CAPTCHA_STAGE_KEY, CAPTCHA_TARGET_KEY, PREV_ZONE_TYPE_KEY } from "../../../../shared/config";
import { convertFieldToString, excludeMessageWithEqualId } from "../../../../shared/lib";
export var getCaptchaStageHistory = function getCaptchaStageHistory(lastSession) {
  var data = sessionStorage.getItem(CAPTCHA_BEFORE_BLOCKING_HISTORY_KEY);
  if (!data) {
    return null;
  }
  return excludeMessageWithEqualId(JSON.parse(data)).filter(function (_ref) {
    var messageId = _ref.messageId;
    return !(lastSession !== null && lastSession !== void 0 && lastSession.messages.find(function (el) {
      return el.messageId === messageId;
    }));
  });
};
export var getQueuedMessages = function getQueuedMessages() {
  var list = sessionStorage.getItem(CAPTCHA_QUEUED_MESSAGES);
  if (!list) {
    return [];
  }
  return JSON.parse(list);
};
export var getPrevZoneType = function getPrevZoneType() {
  return sessionStorage.getItem(PREV_ZONE_TYPE_KEY);
};
var CAPTCHA_KEYS_STORAGE = [CAPTCHA_BEFORE_BLOCKING_HISTORY_KEY, CAPTCHA_TARGET_KEY, CAPTCHA_QUEUED_MESSAGES];
var CAPTCHA_KEYS_COOKIES = [CAPTCHA_STAGE_KEY, CAPTCHA_ACTIVE_MESSAGE_ID, CAPTCHA_RETRY_KEY];
export var resetCaptchaStorage = function resetCaptchaStorage() {
  CAPTCHA_KEYS_STORAGE.forEach(function (key) {
    return sessionStorage.removeItem(key);
  });
  CAPTCHA_KEYS_COOKIES.forEach(function (key) {
    return deleteCookie(key);
  });
};
export var setPrevZoneType = function setPrevZoneType(zoneType) {
  sessionStorage.setItem(PREV_ZONE_TYPE_KEY, convertFieldToString(zoneType));
};